import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'itemTypeProperty';

const itemTypePropertyService = {
  getData: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/data`,
    });
  },

  getItem: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteItem: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  createValue: (itemTypePropertyId, data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/value/${encodeURIComponent(itemTypePropertyId)}`,
      data,
    });
  },

  updateValue: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/value`,
      data,
    });
  },

  deleteValue: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/value/${encodeURIComponent(id)}`,
    });
  },
};

export default itemTypePropertyService;
